import { Arrow, ArrowWrapper, DownArrowWrapper } from './Slide.style'

const SlideDownArrow = ({ isLastSlide }: { isLastSlide: boolean }) => {
  return (
    <DownArrowWrapper isLastSlide={isLastSlide}>
      <ArrowWrapper>
        <Arrow isLastSlide={isLastSlide}>
          <svg
            width='10'
            height='11'
            viewBox='0 0 10 11'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M1 1L5 5L9 1' stroke='#cccccc' strokeLinecap='round' />
            <path d='M1 6L5 10L9 6' stroke='#cccccc' strokeLinecap='round' />
          </svg>
        </Arrow>
      </ArrowWrapper>
    </DownArrowWrapper>
  )
}

export default SlideDownArrow
